import React from "react";
import { Column, Grid, Row } from "cdk-radial";
import { API_DIRECTORY_THEME } from "../../../../utils/constants";
import ApiCard from "./ApiCard";
import "../api-directory.css";

function ApiList({
  title,
  apis = [],
  domainsToDisplay = [],
  entity = {},
  cartDetails,
  apiHomeOnClickHandlers,
  belongsTo,
  orderDetails,
  count,
  requestStatus,
  isMsaConsented,
  requestingOrgId,
  apiBundles
}) {
  const apiCard = (api) => {
    if (belongsTo === API_DIRECTORY_THEME.ISV_API_DIRECTORY) {
      return (
        <a href={`${api.kind}s/${api.id}`}>
          <ApiCard
            key={`api-dir-pkg_spec-card__${api.id}`}
            api={api}
            domainsToDisplay={domainsToDisplay}
            entity={entity}
            cartDetails={cartDetails}
            apiHomeOnClickHandlers={apiHomeOnClickHandlers}
            belongsTo={belongsTo}
            orderDetails={orderDetails}
            requestStatus={requestStatus}
            isMsaConsented={isMsaConsented}
            requestingOrgId={requestingOrgId}
          />
        </a>
      );
    } else
      return (
        <ApiCard
          key={`api-dir-pkg_spec-card__${api.id}`}
          api={api}
          domainsToDisplay={domainsToDisplay}
          entity={entity}
          cartDetails={cartDetails}
          apiHomeOnClickHandlers={apiHomeOnClickHandlers}
          belongsTo={belongsTo}
          orderDetails={orderDetails}
          requestStatus={requestStatus}
          isMsaConsented={isMsaConsented}
          requestingOrgId={requestingOrgId}
          apiBundles={apiBundles}
        />
      );
  };

  if (apis && apis.length) {
    return (
      <div className="api-dir-pkg_spec-list_container">
        <h2 className="api-dir-pkg_api-main-header">APIs ({count})</h2>
        <Grid>
          {title && (
            <Row>
              <div className="api-dir-pkg_spec-list_title">{title}</div>
            </Row>
          )}
          {apis && apis.length ? (
            <Row>
              {apis.map((api, index) => (
                <Column
                  l={2.75}
                  s={3}
                  xs={3}
                  key={index}
                  className="api-dir-col-card"
                >
                  {apiCard(api)}
                </Column>
              ))}
            </Row>
          ) : null}
        </Grid>
      </div>
    );
  } else {
    return null;
  }
}

export default ApiList;
